var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',[(!_vm.uploadRequest.closed)?_c('UploadBar'):_vm._e()],1),_c('div',{staticClass:"home-page"},[_c('div',{staticClass:"home-page-content"},[_c('RequestDetails'),_c('EntryList')],1)]),_c('Footer'),_c('AppAlert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }